// extracted by mini-css-extract-plugin
export var footer_wrapper = "footer-module--footer_wrapper--2KCED";
export var logo_tile = "footer-module--logo_tile--2f0Yw";
export var social_media = "footer-module--social_media--JJUoG";
export var icon = "footer-module--icon--G-PHW";
export var contact_info = "footer-module--contact_info--TM0Bs";
export var tel_ico = "footer-module--tel_ico--QdkIt";
export var more_info = "footer-module--more_info--3CyME";